<template lang="pug">
v-tooltip(right :disabled="!drawerStatus")
  template(#activator="{on, attrs}")
    v-list-item.list-item(
        :class="leftMargin()"
        v-bind="attrs" :value="true"
        :to="item.route" :color="color" v-on="on"
      )
      v-row.flex-nowrap(no-gutters align="center")
        v-col.mr-4(cols="auto" align-self="center")
          component.list-item-icon(
            :is="item.icon.value" 
            v-if="item.icon.type === 'internal'"
            style="height: 24px")
          v-icon.list-item-icon(v-else) {{ item.icon.value }}
        v-col(v-if="!drawerStatus" cols="auto" style="white-space: nowrap")
          span.text-body-2.list-item-title {{ item.title }}
  span {{ item.title }}
</template>

<script>
export default {
  name: "ToolBarBaseItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    drawerStatus: {
      type: Boolean,
      default: false,
    },
    listLevel: {
      type: String,
      default: "0",
    },
    color: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    isSubGroup() {
      return this.listLevel !== "0";
    },
  },
  methods: {
    leftMargin() {
      switch (this.listLevel) {
        case "1":
          return "pl-2";
        case "2":
          return "pl-6";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.list-item
  height: 48px !important

.list-item:hover
  background: none
  .list-item-icon
    color: var(--v-primary-base)
    fill: var(--v-primary-base)
  .list-item-title
    color: var(--v-primary-base)

.v-application .primary--text
  fill: var(--v-primary-base)

.list-item-icon
  display: flex
  align-items: center
  color: var(--v-toolbarText-base)
  fill: var(--v-toolbarText-base)

.v-list-item--active .v-list-item__icon .list-item-icon
  color: var(--v-primary-base)
  fill: var(--v-primary-base)
</style>
